import { Component, Prop, Vue } from "vue-property-decorator";
import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";
import RadioTable from "@/components/RadioTable";
import { db, balaCollection, userDataCollection } from "@/firebase";

@Component
export default class ReadingTask2Understanding extends Vue {
  dialog = false;
  valid = true;
  private balaTasks: any;
  private _passage: [];
  private _questions: [
    { question: string; answer: any; qid: number; header: string }
  ];
  // paragraphs = ["", "", ""];
  completedRadios = [false, false];

  constructor() {
    super();
    this._passage = this.$store.getters.balaPassages.readingTask2;
    this._questions = this.$store.getters.balaUnderstanding.readingTask2;
    this.balaTasks = this.$store.getters.balaSections;
  }

  beforeCreate() {
    this._passage = this.$store.getters.balaPassages.readingTask2;
    this._questions = this.$store.getters.balaUnderstanding.readingTask2;
    this.balaTasks = this.$store.getters.balaSections;
  }

  getData() {
    let data: any = [];
    this._questions.forEach(function(item) {
      data.push({
        question: item.question,
        answer: item.answer, // answer '1' maps to '0' (and so on...) on the responses list.
        qid: item.qid
      });
    });
    return data;
  }

  private isComplete() {
    return (
      this.$store.getters.balaSections[2].sectionProgress.Understanding == 100
    );
  }

  submit() {
    var thisUser = this.$store.getters.user;
    var uid = thisUser.data.uid;
    let data = this.getData();
    let timepoint = this.$store.getters.balaTimepointStr;

    if (
      this.$store.getters.balaSections[2].sectionProgress.Understanding != 100
    ) {
      userDataCollection
        .doc(uid)
        .collection("bala")
        .doc(timepoint)
        .collection("responses")
        .doc("readingTask2")
        .set(
          {
            UnderstandingAnswers: data
          },
          { merge: true }
        )
        .then(function() {
          userDataCollection
            .doc(uid)
            .collection("bala")
            .doc(timepoint)
            .update({
              "completionStatus.readingTask2.understanding": {
                status: true,
                dateCompleted: Date.now()
              }
            });
        })
        .catch(function(error) {
          // console.log(
          //  "Error writing responses for Bala Reading Task 2, Understanding", error
          // );
        });

      // Update progress in $store
      // Update progress in $store
      this.$store.dispatch("updateBalaProgress", {
        section: "Reading Task 2",
        subsection: "Understanding"
      });
    }

    // Move to RT1 questions
    this.$router.push({ name: "balaRT2Questions" });
  }

  stateLoaded() {
    return this.$store.getters.balaUnderstandingLoaded;
  }

  render(h: CreateElement) {
    return (
      this.stateLoaded() && (
        <Card>
          <v-toolbar flat slot="preTitle">
            <div style={{ marginLeft: "auto" }}>
              <v-btn
                onClick={() => {
                  this.dialog = true;
                }}
                color="secondary"
              >
                Show me the passage
              </v-btn>
              <v-dialog v-model={this.dialog}>
                <v-card class="elevation-12">
                  <v-card-title>{this.balaTasks[2].name}</v-card-title>
                  <v-list class="overflow-y-auto" max-height="400">
                    {this._passage.map((line, i) => (
                      <v-list-item>
                        <v-row>
                          <v-col cols="1">{i + 1})</v-col>
                          <v-col cols="11">{line}</v-col>
                        </v-row>
                      </v-list-item>
                    ))}
                  </v-list>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="secondary"
                      onClick={() => {
                        this.dialog = false;
                      }}
                    >
                      Close
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-toolbar>
          <v-form ref="form" v-model={this.valid} slot="mainContent">
            <v-list class="overflow-y-auto" max-height="300">
              {this._questions.map((question, i) =>
                question.answer.constructor !== Array ? (
                  <RadioTable
                    questions={[question]}
                    onUpdate={(completed: boolean) => {
                      this.completedRadios[i] = completed;
                    }}
                    disabled={this.isComplete()}
                    labelType={question.header}
                  ></RadioTable>
                ) : (
                  question.question && this.paragraphQ(question)
                )
              )}
            </v-list>
          </v-form>
          <div slot="actions">
            <v-spacer></v-spacer>
            <v-btn
              disabled={
                !this.isComplete() &&
                (!this.valid || !this.completedRadios.every(obj => obj))
              }
              color="secondary"
              onClick={this.submit}
            >
              Next
            </v-btn>
          </div>
          <div slot="progressBar">
            <v-spacer></v-spacer>
            <v-progress-linear
              value={Math.round(this.$store.getters.progressBala)}
              height="4"
              opacity="0.3"
              striped={true}
            ></v-progress-linear>
          </div>
        </Card>
      )
    );
  }

  private paragraphQ(question: any) {
    let numAnswers = question.answer.length;
    let arr = [<v-toolbar flat>{question.question}</v-toolbar>];
    for (let i = 1; i <= numAnswers; i++) {
      arr.push(
        <v-list-item>
          <v-textarea
            v-model={question.answer[i - 1]}
            counter
            label={`Question ${i}`}
            rules={[
              (v: any) =>
                (v.length > 0 && v.length < 300) || "Max 300 characters"
            ]}
            disabled={this.isComplete()}
          ></v-textarea>
        </v-list-item>
      );
    }
    return arr;
  }
}

const component = ReadingTask2Understanding;
